<ng-container *transloco="let t; read: 'core.PushNotificationPromptComponent'">
    <h2 mat-dialog-title class="mat-title-style">
        <mat-icon>notifications_none</mat-icon>
        {{t('heading')}}
    </h2>

    <div mat-dialog-content class="mat-dialog-style">
        <div class="message">
            <p class="title mb-0">{{t('msg1')}}</p>
            <ol [innerHTML]="t('msg2')"></ol>
            <p style="color: #ca8a03;" class="mb-3" [innerHTML]="t('msg3')"></p>
            <p class="browser-platform" class="mb-3" [innerHTML]="t('msg4', { browser, platform })"></p>
            <ng-container *ngIf="platform == 'ios' || platform == 'mac' ">
                <p>{{t('macMsg1')}}</p>
                <ul [innerHTML]="t('macMsg2')"></ul>
            </ng-container>
            <ng-container *ngIf="platform == 'ios' ">
                <p class="mb-3">{{t('iosMsg1')}}</p>
                <ul>
                    <li>
                        {{t('iosMsg2')}}
                        <a href="https://support.apple.com/en-in/guide/iphone/iph42ab2f3a7/16.0/ios/16.0#iph4f9a47bbc"
                            target="_blank">
                            https://support.apple.com/en-in/guide/iphone/iph42ab2f3a7/16.0/ios/16.0#iph4f9a47bbc
                        </a>
                    </li>
                    <li>
                        {{t('iosMsg3')}}
                        <a href="https://support.apple.com/en-in/guide/iphone/iph7c3d96bab/16.0/ios/16.0"
                            target="_blank">
                            https://support.apple.com/en-in/guide/iphone/iph7c3d96bab/16.0/ios/16.0
                        </a>
                    </li>
                </ul>
            </ng-container>
            <ng-container *ngIf="platform != 'ios' && platform != 'mac'">
                <p class="mb-3" *ngIf=" browser == 'chrome' ">
                    {{t('windowMsg')}}
                    <a href="https://support.google.com/chrome/answer/3220216#zippy=%2Cfix-issues-with-notifications"
                        target="_blank">
                        https://support.google.com/chrome/answer/3220216#zippy=%2Cfix-issues-with-notifications
                    </a>
                </p>

                <p class="mb-3" *ngIf="browser == 'firefox'">
                    {{t('firefoxMsg')}}
                    <a href="https://support.mozilla.org/en-US/kb/push-notifications-firefox#w_how-do-i-revoke-web-push-permissions-for-a-specific-site"
                        target="_blank">
                        https://support.mozilla.org/en-US/kb/push-notifications-firefox#w_how-do-i-revoke-web-push-permissions-for-a-specific-site
                    </a>
                </p>

                <p class="mb-3" *ngIf="browser == 'opera'">
                    {{t('operaMsg')}}
                    <a href="https://help.opera.com/en/latest/web-preferences/#notifications" target="_blank">
                        https://help.opera.com/en/latest/web-preferences/#notifications
                    </a>
                </p>

                <p class="mb-3" *ngIf="browser == 'opera-mini'">
                    {{t('operaMiniMsg')}}
                    <a href="https://help.opera.com/en/latest/web-preferences/#notifications" target="_blank">
                        https://help.opera.com/en/latest/web-preferences/#notifications
                    </a>
                </p>
            </ng-container>
        </div>
    </div>

    <div mat-dialog-actions class="action-buttons">
        <button mat-button mat-stroked-button class="btn-dark" [mat-dialog-close]="false">
            {{t('noThanks')}}
        </button>
        <button cdkFocusInitial mat-raised-button color="primary" (click)="confirmClick()" class="btn-dark">
            {{t('allow')}}
        </button>
    </div>

</ng-container>